import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Inject preconnect + preload hints into <head> immediately
const head = document.head;
// Preconnect to CDN (saves ~220ms on LCP)
const preconnectCDN = document.createElement('link');
preconnectCDN.rel = 'preconnect';
preconnectCDN.href = 'https://cdn.magicpatterns.com';
head.appendChild(preconnectCDN);
// Preconnect to Facebook (for Meta Pixel)
const preconnectFB = document.createElement('link');
preconnectFB.rel = 'preconnect';
preconnectFB.href = 'https://connect.facebook.net';
head.appendChild(preconnectFB);
// Preload hero image (LCP element)
const preloadHero = document.createElement('link');
preloadHero.rel = 'preload';
preloadHero.as = 'image';
preloadHero.href = 'https://cdn.magicpatterns.com/uploads/8zRS2mHcecLm1ubrFD3VLb/ChatGPT-Image-27-ene-2026_-02_13_39.webp';
preloadHero.type = 'image/webp';
head.appendChild(preloadHero);
// Remove unused Google Fonts preconnects if present
document.querySelectorAll('link[rel="preconnect"][href*="fonts.googleapis"], link[rel="preconnect"][href*="fonts.gstatic"]').forEach(el => el.remove());
render(<App data-id="element-107" />, document.getElementById('root'));